// Create a simple event bus
export const createEventBus = () => {
    const subscribers = [];
    return {
        subscribe: (callback) => {
            subscribers.push(callback);
            // Return unsubscribe function
            return () => {
                const index = subscribers.indexOf(callback);
                if (index !== -1) {
                    subscribers.splice(index, 1);
                }
            };
        },
        publish: (id) => {
            subscribers.forEach((callback) => callback(id));
        }
    };
};
